import {filter, lazy, trigger} from './lang.js';

export const slide = (transpose, duration) => {
  return (... args) => {
    let [stepData, stepNumber, time, effect] = args;
      if (!stepData) {
          return filter(false);
      }
    let copiedStepData = effect.getStep(stepData);
    copiedStepData.slide = true;
    copiedStepData.transpose = (
      stepData.transpose + lazy(transpose, ... args)
      );
      if (duration !== undefined) {
          copiedStepData.duration = lazy(duration, ...args);
          
      }
      return trigger([
          { stepData, stepNumber, time},
          { stepData: copiedStepData, stepNumber, time}
      ]);
  }
};
